<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :sort-by="['created_at']"
    :sort-desc="true"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('DATA_TABLE.SEARCH')"
        outlined
        append-icon="mdi-magnify"
      ></v-text-field>
    </template>

    <template v-slot:item.last_name="{ item }">
      {{ item.last_name }}
      <v-tooltip v-if="!item.email_verified" top>
        <template v-slot:activator="{ on }">
          <v-icon color="red" v-on="on">
            mdi-alert-circle
          </v-icon>
        </template>
        <span>{{ $t('DASHBOARD.UNCONFIRMED_EMAIL') }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | dateFormat }}
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'RegistrationList',

  filters: {
    dateFormat
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    search: ''
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'first_name'
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'last_name'
        },
        {
          text: this.$t('DASHBOARD.NAME_APP'),
          value: 'reg_source'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex_name'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          value: 'business_customer_name'
        },
        {
          text: this.$t('ITEM.CREATED_AT'),
          value: 'created_at'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  }
};
</script>
